import { cn } from "@/lib/utils";

/**
 * A round portrait when one is known (currently only the four AI agents —
 * see `lib/agent-avatars.ts`), otherwise the initials circle every "who did
 * this" spot in the app already drew by hand. One component so a person
 * (comment author, watcher, agent) always renders the same way wherever
 * they show up.
 */
export function Avatar({
  src,
  name,
  size = 28,
  className,
}: {
  src?: string | null | undefined;
  name?: string | null | undefined;
  size?: number;
  className?: string;
}) {
  if (src) {
    return (
      <img
        src={src}
        alt={name ?? ""}
        className={cn("shrink-0 rounded-full object-cover", className)}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full bg-primary/10 font-bold text-primary",
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }}
    >
      {(name ?? "?").charAt(0).toUpperCase()}
    </div>
  );
}
